export default __webpack_public_path__ + "static/media/poc_two.9fa5f735.usdz";